import { NumericFormat } from 'react-number-format';
import getSymbolFromCurrency from 'currency-symbol-map'
import MoneyInterface from "../../interfaces/core/MoneyInterface";

export default function Money({value, decimalScale = 2}: {value: MoneyInterface, decimalScale?: number}){
    return <><NumericFormat value={value.amount / 100} displayType={'text'} thousandSeparator={' '} decimalScale={decimalScale} fixedDecimalScale renderText={(value) => { return value; }} />  {getSymbolFromCurrency(value.currency.name)}</>
}